import { Table } from '@fortress-technology-solutions/fortress-component-library/Organisms_Fortress';
import useBaseTableProps from '../../../../hooks/useBaseTableProps';
import { useManageScheduledReports } from '../../hooks';
import { SCHEDULED_REPORTS_NAME } from '../../constants';

const ScheduledReportsTab = ({
  organizationId,
  userId,
  username,
  tableHeight,
  onViewEdit,
}) => {
  const baseTableProps = useBaseTableProps();

  const {
    allColumnsHidden,
    columnOptions,
    count,
    dateState,
    filterState,
    filterTypeState,
    filteredHeaders,
    handleColumnChange,
    handleDateSubmit,
    handleFilterChange,
    handleFilterTypeChange,
    handleSearchSubmit,
    handleSortChange,
    isLoading,
    name,
    order,
    orderBy,
    rows,
    selectedColumns,
    totalCount,
  } = useManageScheduledReports({
    NAME: SCHEDULED_REPORTS_NAME,
    organizationId,
    userId,
    username,
    onViewEdit,
  });

  return (
    <Table
      {...baseTableProps}
      height={tableHeight}
      allColumnsHidden={allColumnsHidden}
      columnOptions={columnOptions}
      count={count}
      dateState={dateState}
      filterState={filterState}
      filterTypeState={filterTypeState}
      handleColumnChange={handleColumnChange}
      handleDateSubmit={handleDateSubmit}
      handleFilterChange={handleFilterChange}
      handleFilterTypeChange={handleFilterTypeChange}
      handleSearchSubmit={handleSearchSubmit}
      handleSortChange={handleSortChange}
      headers={filteredHeaders}
      isLoading={isLoading}
      name={name}
      order={order}
      orderBy={orderBy}
      rows={rows}
      selectedColumns={selectedColumns}
      totalCount={totalCount}
    />
  );
};

export default ScheduledReportsTab;
